import { QuestionType } from "@/types/question";
import {
	defaultChecklistOptions,
	yesNoOptions,
} from "../constants/questionDefaults";
import type {
	QuestionOption,
	QuestionTypeOrChecklist,
} from "../hooks/useQuestionForm";

export function getRenderedOptions(
	selectedType: QuestionTypeOrChecklist | null,
	options: QuestionOption[]
): QuestionOption[] {
	if (selectedType === QuestionType.Boolean) {
		return yesNoOptions;
	}
	if (selectedType === 999) {
		return defaultChecklistOptions;
	}
	if (selectedType === QuestionType.Option) {
		return options;
	}
	return [];
}
